<template>
  <div style="padding-bottom: 10em;">
    <header-main />
    <router-view />
  </div>
</template>

<script>

  import HeaderMain from '@/components/includes/HeaderMain.vue'

  export default {
    name: 'SearchNavigation',
    components: {
      HeaderMain
    }
  }
</script>

<style lang="scss" scoped>
</style>